import _regeneratorRuntime from "D:\\new-code\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { if (i % 2) { var source = arguments[i] != null ? arguments[i] : {}; ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(arguments[i])); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(arguments[i], key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import RichCourseItem from "../../components/rich/CourseItem.vue";
import OtoScheduleTable from "../../components/OtoScheduleTable.vue";
import ScheduleTable from "@/components/schedule/ScheduleTable.vue";
import Complaint from "@/components/community/components/Complaint.vue";
import List from "@/components/List.vue";
export default {
  name: "LecturerShow",
  components: {
    OtoScheduleTable: OtoScheduleTable,
    ScheduleTable: ScheduleTable,
    RichCourseItem: RichCourseItem,
    Complaint: Complaint,
    List: List
  },
  computed: {
    tabs: function tabs() {
      var tabs = []; // tabs.push({ id: 0, name: "讲师简介" });

      tabs.push({
        id: 1,
        name: "主讲课程"
      });

      if (!this.isNormal && this.$store.state.commonSetting.switch_oto_module == 1 || this.isPerios) {
        tabs.push({
          id: 2,
          name: "约课课表"
        });
        tabs.push({
          id: 3,
          name: "讲师评价"
        });
      }

      return tabs;
    },
    commonSetting: function commonSetting() {
      return this.$store.state.commonSetting;
    },
    userId: function userId() {
      return this.$store.state.user_info.id;
    }
  },
  data: function data() {
    return {
      course_classify: [],
      //分类列表
      contracts_id: "",
      //已选课时包
      subjectList: [],
      //科目列表
      periodList: [],
      //课次列表
      period: "",
      //预约课次
      id: "",
      teacher: {},
      inviteTeacher: {},
      isNormal: true,
      //是否是普通讲师,进而用于可以判断是否是计费约课讲师 true：非计费约课讲师 false:计费约课讲师
      isPerios: false,
      //是否是课时约课讲师 true:是,false：是
      periodsDlgShow: false,
      appointSuccessDlg: false,
      gradeRadioValue: null,
      subjectsRadioValue: null,
      classifyRadioValue: null,
      flag: 2,
      tab: 1,
      attrs: [],
      intro: "",
      packageList: [],
      //课时包列表
      courses: [],
      pageAppraise: 1,
      limitAppraise: 10,
      totalAppraise: 0,
      pageEvaluate: 1,
      is_set_chapters: 2,
      limitEvaluate: 10,
      totalEvaluate: 0,
      tags: [],
      appraiseList: [],
      evaluateList: [],
      lastRoute: {
        name: this.$route.query.route_name || "Oto",
        label: this.$route.query.route_label || "一对一"
      },
      is_next: 0,
      weekTab: {
        0: "本周课表",
        1: "下周课表"
      },
      sort: 0,
      params: {
        teacher_id: "",
        order_by: 0
      },
      active: 1,
      evaluate_active: 1,
      table: {},
      settingDate: [],
      courseTimes: {
        0: {},
        1: {},
        2: {},
        3: {},
        4: {},
        5: {},
        6: {}
      },
      clickInviteCourse: {},
      warningText: "",
      select_grade: [],
      select_classify: [],
      select_subject: []
    };
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var data, dataAttr;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.id = this.$route.params.id;
              this.params.teacher_id = this.$route.params.id;
              _context.next = 4;
              return this.$http.get("/api/app/teacher/" + this.id);

            case 4:
              data = _context.sent;
              this.isPerios = data.inviteTeacher.length != 0;
              this.teacher = data.teacher;
              this.inviteTeacher = data.inviteTeacher;
              this.isNormal = !!data.teacher.real_name;
              this.flag = data.flag;

              if (!this.isNormal && !this.isPerios) {
                this.active = 2;
                this.evaluate_active = 2;
              }

              _context.next = 13;
              return this.$http.get("/api/app/teacher/info/" + this.id);

            case 13:
              dataAttr = _context.sent;
              dataAttr.attr.forEach(function (a) {
                var attr_value_names = [];
                a.attr_value.forEach(function (av) {
                  attr_value_names.push(av.attr_value_name);
                });
                a.attr_value_names = attr_value_names.join(",");
              });
              this.attrs = dataAttr.attr;
              this.intro = (dataAttr.intro || "").replace(/\n/g, "<br/>"); // await this.getAppraise();
              // this.getPeriodsEvaluate(); //请求课时约课评价

              this.getOptionalList();

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    getTitle: function getTitle(value) {
      if (value && value.length > 0) {
        var data = value.map(function (item) {
          return item.name;
        });
        return data.join("/");
      }

      return "";
    },
    //科目change
    changeSub: function () {
      var _changeSub = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(value) {
        var data, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.period = [];
                this.periodList = [];
                data = this.subjectList.find(function (item) {
                  return item.contracts_item_id == value;
                }); //获取contracts_item_id

                if (!data) {
                  _context2.next = 9;
                  break;
                }

                //查询课次
                this.is_set_chapters = data.is_set_chapters;
                _context2.next = 7;
                return this.$http.get("/api/app/inviteTeacher/optionalChapter/".concat(data.contracts_item_id));

              case 7:
                res = _context2.sent;

                if (res && res.length > 0) {
                  res.forEach(function (item) {
                    item.label = item.title;
                    item.value = item.id;
                    item.children.forEach(function (i) {
                      i.label = i.title;
                      i.value = i.id;
                    });
                  });
                  this.periodList = res;
                }

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function changeSub(_x) {
        return _changeSub.apply(this, arguments);
      }

      return changeSub;
    }(),
    //课时包change
    changePackage: function () {
      var _changePackage = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(value) {
        var _this = this;

        var data;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.is_set_chapters = 2;
                this.subjectsRadioValue = "";
                this.period = [];
                this.periodList = [];
                this.classifyRadioValue = null;
                this.subjectList = [];
                this.course_classify = [];
                data = this.packageList.find(function (item) {
                  return item.contracts_id == value;
                });
                this.packageList.forEach(function (item) {
                  if (_this.contracts_id == item.contracts_id) {
                    _this.gradeRadioValue = item.grade_id;
                  }
                });

                if (data) {
                  this.course_classify = [{
                    classify_id: data.classify_id,
                    classify_name: data.classify_name
                  }];
                  this.subjectList = data.contracts_item || [];
                }

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function changePackage(_x2) {
        return _changePackage.apply(this, arguments);
      }

      return changePackage;
    }(),
    //获取合同数据
    getOptionalList: function () {
      var _getOptionalList = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var res;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this.$store.state.token && this.$store.getters.getSwitch("contract"))) {
                  _context4.next = 5;
                  break;
                }

                _context4.next = 3;
                return this.$http.get("/api/app/inviteTeacher/optionalContracts/".concat(this.id));

              case 3:
                res = _context4.sent;
                this.packageList = res || [];

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getOptionalList() {
        return _getOptionalList.apply(this, arguments);
      }

      return getOptionalList;
    }(),
    GetScheduleTable: function GetScheduleTable(data) {
      var _this2 = this;

      this.settingDate = data.date;
      this.table = data;
      this.courseTimes = {
        0: {},
        1: {},
        2: {},
        3: {},
        4: {},
        5: {},
        6: {}
      };
      data.invite_course.forEach(function (i) {
        var pos = _this2.getCourseTimePos(i.start_play_date, i.timetable_id);

        if (!pos) return;
        var status; //1可预约单元格 ,2约满单元格(别人) ,3自己约的,4过期

        if (i.is_expired == 1) {
          status = 4;
        } else if (i.user_id == 0 && i.confirm_at == 0) {
          status = 1; //可预约
        } else {
          status = i.user_id == _this2.userId ? 3 : 2;
        }

        var data = _objectSpread({}, i, {
          status: status
        });

        _this2.courseTimes[pos.week][pos.time_id] = data;
      });
    },
    getCourseTimePos: function getCourseTimePos(dateStr, timeId) {
      var week = this.table.date.findIndex(function (i) {
        return i.date == dateStr;
      });
      var time = this.table.course_time.find(function (i) {
        return i.id == timeId;
      });
      return week != -1 && time ? {
        week: week,
        time_id: time.id
      } : null;
    },
    collect: function () {
      var _collect = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.$http.get("/api/app/teacher/collect/" + this.id, {}, true);

              case 2:
                this.$message({
                  message: "收藏成功",
                  type: "success"
                });
                this.flag = 1;

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function collect() {
        return _collect.apply(this, arguments);
      }

      return collect;
    }(),
    cancelCollect: function () {
      var _cancelCollect = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.$http.get("/api/app/teacher/collect/" + this.id);

              case 2:
                this.$message({
                  message: "取消收藏成功",
                  type: "success"
                });
                this.flag = 2;

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function cancelCollect() {
        return _cancelCollect.apply(this, arguments);
      }

      return cancelCollect;
    }(),
    changeTab: function changeTab(item) {
      this.tab = item.id;
    },
    changeChildTab: function changeChildTab(tab) {
      this.active = tab;
    },
    changeEvaluateChildTab: function changeEvaluateChildTab(tab) {
      this.evaluate_active = tab;
    },
    getAppraise: function () {
      var _getAppraise = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var data, tags, appraiseList;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.$http.post("/api/app/teacher/comment?teacher_id=" + this.id, {
                  page: this.pageAppraise,
                  limit: this.limitAppraise
                });

              case 2:
                data = _context7.sent;
                tags = data.tag;
                tags = tags.sort(function (a, b) {
                  return b.count - a.count;
                });
                this.tags = tags;
                this.totalAppraise = data.comment.total;
                appraiseList = data.comment.list;
                appraiseList.forEach(function (a) {
                  var times = a.course_time.split(" ");
                  times[0] = times[0].replace(/-/g, "/");
                  a.course_time = times.join(" ");

                  if (!a.tag_content) {
                    return;
                  }

                  a.tags = a.tag_content.split(",");
                });
                this.appraiseList = appraiseList;

              case 10:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getAppraise() {
        return _getAppraise.apply(this, arguments);
      }

      return getAppraise;
    }(),
    getPeriodsEvaluate: function () {
      var _getPeriodsEvaluate = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        var data;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.$http.post("/api/app/teacher/comment?teacher_id=" + this.id, {
                  page: this.pageEvaluate,
                  limit: this.limitEvaluate
                });

              case 2:
                data = _context8.sent;
                this.totalEvaluate = data.inviteComment.total;
                this.evaluateList = data.inviteComment.list;

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getPeriodsEvaluate() {
        return _getPeriodsEvaluate.apply(this, arguments);
      }

      return getPeriodsEvaluate;
    }(),
    handleAppraiseChange: function () {
      var _handleAppraiseChange = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(page) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this.pageAppraise = page; // await this.getAppraise();

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function handleAppraiseChange(_x3) {
        return _handleAppraiseChange.apply(this, arguments);
      }

      return handleAppraiseChange;
    }(),
    handleEvaluateChange: function () {
      var _handleEvaluateChange = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10(page) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                this.pageEvaluate = page; // await this.getPeriodsEvaluate();

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function handleEvaluateChange(_x4) {
        return _handleEvaluateChange.apply(this, arguments);
      }

      return handleEvaluateChange;
    }(),
    onCommentDelete: function () {
      var _onCommentDelete = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11(item) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.$promiseConfirm("删除后，该内容将不再展示，是否确认？", {
                  type: "warning"
                });

              case 2:
                _context11.next = 4;
                return this.$http.delete("/api/app/oto/comment/" + item.id);

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function onCommentDelete(_x5) {
        return _onCommentDelete.apply(this, arguments);
      }

      return onCommentDelete;
    }(),
    onComplaint: function onComplaint(item) {
      this.$refs.complaint.show(2, item.id);
    },
    changeSort: function changeSort(sort) {
      this.sort = sort;
      this.params.order_by = sort;
      this.$refs.list.searchRefresh();
    },
    resetDlg: function resetDlg() {
      this.is_set_chapters = 2;
      this.gradeRadioValue = null;
      this.classifyRadioValue = null;
      this.subjectsRadioValue = null;
      this.course_classify = [];
      this.contracts_id = null;
      this.subjectList = []; //科目列表

      this.periodList = []; //课次列表

      this.period = "";
      this.warningText = "";
    },
    closeDlg: function closeDlg() {
      this.resetDlg();
      this.periodsDlgShow = false;
    },
    onAppointment: function onAppointment(inviteCourseItem) {
      if (!this.$store.state.token) {
        this.$LoginModal.login({
          type: "passwordLogin",
          store: this.$store
        });
        return false;
      }

      this.clickInviteCourse = inviteCourseItem;
      this.periodsDlgShow = true;
    },
    submitAppointment: function () {
      var _submitAppointment = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12() {
        var _this3 = this;

        var params, data;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!(this.commonSetting.switch_sch_attr_grade == 1 && this.gradeRadioValue == null)) {
                  _context12.next = 3;
                  break;
                }

                this.$message({
                  type: "error",
                  message: "请选择年级"
                });
                return _context12.abrupt("return");

              case 3:
                if (this.contracts_id) {
                  _context12.next = 6;
                  break;
                }

                this.$message({
                  type: "error",
                  message: "请选择课时包"
                });
                return _context12.abrupt("return");

              case 6:
                if (!(this.commonSetting.switch_sch_attr_classify == 1 && this.classifyRadioValue == null)) {
                  _context12.next = 9;
                  break;
                }

                this.$message({
                  type: "error",
                  message: "请选择分类"
                });
                return _context12.abrupt("return");

              case 9:
                if (!(this.subjectsRadioValue == null)) {
                  _context12.next = 12;
                  break;
                }

                this.$message({
                  type: "error",
                  message: "请选择科目"
                });
                return _context12.abrupt("return");

              case 12:
                params = {
                  invite_course_id: this.clickInviteCourse.id,
                  teacher_id: this.inviteTeacher.teacher_id,
                  grade_id: this.gradeRadioValue,
                  course_classify_id: this.classifyRadioValue,
                  // subject_id: this.subjectsRadioValue,
                  contracts_item_id: this.subjectsRadioValue,
                  chapter_id: this.period && this.period.length > 0 ? this.period[1] : ""
                };
                _context12.next = 15;
                return this.$http.post("/api/app/inviteTeacher/inviteTeacherCourse", params);

              case 15:
                data = _context12.sent;

                if (data.error) {
                  this.warningText = data.error;
                } else {
                  this.periodsDlgShow = false;
                  this.packageList.forEach(function (item) {
                    if (_this3.contracts_id == item.contracts_id) {
                      _this3.select_grade = [{
                        id: item.grade_id,
                        grade_id: item.grade_id,
                        name: item.grade_name,
                        grade_name: item.grade_name
                      }];
                      _this3.gradeRadioValue = item.grade_id;
                    }
                  });
                  this.select_classify = this.course_classify.filter(function (item) {
                    return item.classify_id == _this3.classifyRadioValue;
                  });
                  this.select_subject = this.subjectList.filter(function (item) {
                    return item.contracts_item_id == _this3.subjectsRadioValue;
                  });
                  this.resetDlg();
                  this.periodsDlgShow = false;
                  this.appointSuccessDlg = true;
                  this.$refs.scheduleTable.requestTable();
                }

              case 17:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function submitAppointment() {
        return _submitAppointment.apply(this, arguments);
      }

      return submitAppointment;
    }(),
    onCloseAppointSuccessDlg: function onCloseAppointSuccessDlg() {
      this.select_grade = [];
      this.select_classify = [];
      this.select_subject = [];
      this.appointSuccessDlg = false;
    }
  }
};